export default __webpack_public_path__ + "static/media/icon-snappy-process.381832ce.svg";